import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classnames from 'classnames';

// Selector
import { selectPinnedSidebar } from '../../../../services/ui/selectors';

// Styles
import './styles.scss';

interface Props {
    children: React.Node;
    pinned: boolean;
}

class SidebarNavigationPusher extends React.PureComponent<Props> {
    render() {
        const { children, pinned } = this.props;
        return (
            <div
                className={classnames('sidebar-navigation-pusher', {
                    open: pinned
                })}
            >
                {children}
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    pinned: selectPinnedSidebar
});

export default connect(mapStateToProps)(SidebarNavigationPusher);
